import React from "react";
import classNames from "classnames";
import { path } from "../../../utils/path";

import Bouton, { VARIANT as boutonVARIANT, SIZE as boutonSIZE } from "../../bouton";
import BoutonLink from "../../boutonLink";

import styles from "./uiDesktop.module.scss";
import { Categorie } from "@/types/categorie";

type PropTypes = {
    categoriesHierachy: Array<Categorie>;
    categoryId: number;
    categoryParent: Categorie;
    className?: string;
};

const UiDesktop = ({
    categoriesHierachy,
    categoryId,
    categoryParent,
    className = "",
}: PropTypes) => {
    const categoryParentLinkTo = path.fill(path.CATEGORY, categoryParent);

    return (
        <div
            className={classNames(styles.me, {
                [className]: className,
            })}
        >
            <div className={styles.categoryList}>
                <ul>
                    <li data-catid={categoryParent.id}>
                        <BoutonLink
                            href={categoryParentLinkTo}
                            size={boutonSIZE.SM}
                            variant={boutonVARIANT.BORDER}
                        >
                            Tous
                        </BoutonLink>
                    </li>
                    {categoriesHierachy &&
                        categoriesHierachy.map((category) => {
                            const { id, nom } = category;

                            if (id === categoryId) {
                                return (
                                    <li data-catid={id} key={`cuisiner-categoryList-${id}`}>
                                        <Bouton
                                            disabled
                                            size={boutonSIZE.SM}
                                            variant={boutonVARIANT.PRIMARY}
                                        >
                                            {nom}
                                        </Bouton>
                                    </li>
                                );
                            }

                            const categoryLinkTo = path.fill(path.CATEGORY, category);
                            return (
                                <li data-catid={id} key={`cuisiner-categoryList-${id}`}>
                                    <BoutonLink
                                        href={categoryLinkTo}
                                        size={boutonSIZE.SM}
                                        variant={boutonVARIANT.BORDER}
                                    >
                                        {nom}
                                    </BoutonLink>
                                </li>
                            );
                        })}
                </ul>
            </div>
        </div>
    );
};

export default UiDesktop;
